var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCafeCalendar = function SvgCafeCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03 6.764c-1.605 0-2.905 1.431-2.905 3.197v6.328c0 1.766 1.3 3.197 2.905 3.197h7.94c1.604 0 2.905-1.431 2.905-3.197V9.96c0-1.766-1.3-3.197-2.905-3.197H8.03ZM3.75 9.96c0-2.602 1.916-4.711 4.28-4.711h7.94c2.364 0 4.28 2.11 4.28 4.711v6.328c0 2.602-1.916 4.711-4.28 4.711H8.03c-2.364 0-4.28-2.11-4.28-4.711V9.96Z",
    fill: "#102B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 10.5c0-.414.308-.75.688-.75h15.125c.38 0 .687.336.687.75s-.308.75-.688.75H4.438c-.38 0-.687-.336-.687-.75ZM8.333 3a.75.75 0 0 1 .75.75v4.415a.75.75 0 0 1-1.5 0V3.75a.75.75 0 0 1 .75-.75ZM15.667 3a.75.75 0 0 1 .75.75v4.415a.75.75 0 0 1-1.5 0V3.75a.75.75 0 0 1 .75-.75Z",
    fill: "#102B3F"
  })));
};
export default SvgCafeCalendar;